const nullify = () => {
    return {
        type : 'NULLIFY'
    }

}
export default nullify;